import React, { FC } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import Button from '../UI/Button';
import { RootState } from '../../store';
import { signout } from '../../store/actions/authActions';
//import firebase from 'firebase';
import logo from '../../nalij_logo.png';

const Header: FC = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { authenticated, user } = useSelector((state: RootState) => state.auth);

  const logoutClickHandler = () => {
    dispatch(signout());
  }

  return(
    <nav className="navbar is-spaced has-shadow">
      <div className="container">
        <div className="navbar-brand">
          <Link className="navbar-item" to={!authenticated ? "/" : "/dashboard"}>
          <img className="img-fluid" src={logo} alt="Logo"/>Article Narration Project <span className="mvp"><sup>MVP</sup></span>
          </Link>
        </div>

        <div className="navbar-end">

            {!authenticated ?
              <div className="buttons">
                <div className="navbar-item">
                  <Button text="Save Your Playlist" onClick={() => history.push('/signup')} className="is-primary is-size-7" />
                </div>
                <div className="navbar-item">
                  <Button text="Load Your Playlist" onClick={() => history.push('/signin')}  className="is-size-7"/>
                </div>
              </div>
              :
              <div className="buttons">
                <div className="navbar-item">
                  Hi <b>{user?.firstName}</b>
                </div>
                <div className="navbar-item signout">
                  <Button text="Sign out" onClick={logoutClickHandler} />
                </div>
              </div>
            }
        </div>
      </div>
    </nav>
  );
}

export default Header;
